/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { matchPath } from "react-router";
import queryString from "query-string";
import isEqual from "lodash.isequal";
import { Col, NavLink } from "reactstrap";
import SVG from "../../components/SVG";
import { ModalShare } from "../../components/complex/ModalShare/ModalShare";
import {
  Button,
  Container,
  LoadingIndicator,
  Row,
  Table
} from "../../components/simple";
import Header from "../../components/complex/Header";
import SearchInput from "../../components/complex/SearchInput";
import { ModalAudienceForm } from "../../components/forms/CreateAudienceDescription";
import Filters from "./TableFilters";
import AudienceRow from "./AudienceRow";

import {
  AccessControl,
  checkPermissions,
  permissions
} from "../../components/permissions";

import PushModal from "./PushModal";

// some needed redux actions
import {
  clearAudiences,
  clearPresets,
  clearStateBeforeSearchRequest,
  setAudiencesPaginationOffset,
  setPresetsPaginationOffset
} from "../../store/entities/audience/audience.actions";

import * as routes from "../../router/routes";
import Api from "../../api";

import "../../styles/pages/audiences.scss";

class AudienceScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        type: "",
        country: "",
        createdBy: ""
      },
      curType: "",
      backendSearchTerm: "",
      descriptionData: {},
      isDescriptionModalOpen: false,
      isAnalysisModalOpen: false,
      customerAnalysisError: false,
      limit: 15,
      loadPresetsAfterAudiences: false,
      adformToken: "",
      snapchatToken: "",
      isShowPushModal: false,
      isSelectClientModalHasOpened: false
      // selectedClient: null
    };

    this.audienceRef = React.createRef();
    this.timer = null;

    this.removeAudience = this.removeAudience.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeFilter = this.handleChangeFilter.bind(this);
    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
    this.handleDescriptionModal = this.handleDescriptionModal.bind(this);
    this.handleAudienceCreate = this.handleAudienceCreate.bind(this);
    this.handleLoadMore = this.handleLoadMore.bind(this);
    this.handleBackendSearchTermChange = this.handleBackendSearchTermChange.bind(
      this
    );
    this.handleBackendFilterChange = this.handleBackendFilterChange.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    if (Array.isArray(props.audiences.data)) {
      return {
        audiences: [...props.audiences.data]
      };
    }

    return state;
  }

  async componentDidMount() {
    const {
      user: {
        company: { currentSubscription }
      },
      clearState
    } = this.props;

    const searchParamsFromSignInRedirect = queryString.parse(
      this.props.location.search
    );

    if (searchParamsFromSignInRedirect.adformToken) {
      this.setState({
        adformToken: searchParamsFromSignInRedirect.adformToken,
        // selectedClient: this.props.location.state.clientId,
        isShowPushModal: true
      });
    }

    if (searchParamsFromSignInRedirect.snapchatToken) {
      this.setState({
        snapchatToken: searchParamsFromSignInRedirect.snapchatToken,
        // selectedClient: this.props.location.state.clientId,
        isShowPushModal: true
      });
    }

    // Cancel unnecesary requests for backend search
    // this.axiosCancelSource = axios.CancelToken.source();

    await Api.audience.countries({
      params: {
        has_data: true
      }
    });

    await Api.user.getProfiles();

    clearState();

    if (currentSubscription !== "Light") {
      await Api.client.get();
      await this.getAudiences();
    } else {
      await this.getPresets();
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    const {
      location: { pathname, search },
      audiences: {
        audiencesOffset,
        presetsOffset,
        audiencesNext,
        presetsNext,
        isDublicateSuccess
      }
    } = this.props;

    const { filters, loadPresetsAfterAudiences } = this.state;

    const {
      location: { pathname: prevPathname, search: prevSearch },
      audiences: { isDublicateSuccess: prevIsDublicateSuccess }
    } = prevProps;

    if (prevPathname !== pathname || search !== prevSearch) {
      await this.getAudiences();
    }

    const isNewBackendSearchOrFiltering =
      prevState.backendSearchTerm !== this.state.backendSearchTerm ||
      !isEqual(prevState.filters, this.state.filters) ||
      (prevIsDublicateSuccess !== isDublicateSuccess && isDublicateSuccess);

    if (isNewBackendSearchOrFiltering) {
      this.handleCheck();
    } else if (
      this.props.audiences.audiencesOffset !== 0 &&
      prevProps.audiences.audiencesOffset !== audiencesOffset &&
      filters.createdBy !== "GDR"
    ) {
      await this.getAudiences();
    } else if (
      this.props.audiences.presetsOffset !== 0 &&
      prevProps.audiences.presetsOffset !== presetsOffset
    ) {
      await this.getPresets();
    } else if (
      presetsOffset === 0 &&
      audiencesNext === "" &&
      presetsNext === "" &&
      loadPresetsAfterAudiences
    ) {
      await this.getPresets();
    }
  }

  async getAudiences(isNewBackendSearchOrFiltering) {
    const {
      limit,
      backendSearchTerm,
      filters: { type, country, createdBy }
    } = this.state;

    const {
      location,
      audiences: { audiencesOffset },
      userProfiles
    } = this.props;

    const matched = matchPath(location.pathname, {
      path: routes.audiences(routes.slugId),
      exact: true,
      strict: false
    });

    const id = (matched.params && matched.params.id) || "";
    await Api.audience.countries({
      params: {
        has_data: true
      }
    });

    let currentUserProfile;

    if (createdBy !== "") {
      currentUserProfile = userProfiles.find(user => user.name === createdBy);
    }

    await Api.audience.get({
      id,
      params: {
        limit,
        offset: audiencesOffset,
        search: backendSearchTerm,
        audience_type: type,
        country,
        created_by: currentUserProfile ? currentUserProfile.id : ""
      },
      isNewBackendSearchOrFiltering
    });
  }

  async getPresets(isNewBackendSearchOrFiltering) {
    const {
      limit,
      backendSearchTerm,
      filters: { type, country },
      loadPresetsAfterAudiences
    } = this.state;

    const {
      audiences: { presetsOffset, audiencesNext, presetsNext }
    } = this.props;

    if (
      presetsOffset === 0 &&
      audiencesNext === "" &&
      presetsNext === "" &&
      loadPresetsAfterAudiences
    ) {
      this.setState({
        loadPresetsAfterAudiences: false
      });
    }

    await Api.audience.presets({
      params: {
        limit,
        offset: this.props.audiences.presetsOffset,
        search: backendSearchTerm,
        audience_type: type,
        country,
        created_by: ""
      },
      isNewBackendSearchOrFiltering
    });
  }

  handleAudienceRowClick = audience => {
    const { user, history } = this.props;

    if (this.state.isSelectClientModalHasOpened) return;

    const permitted = checkPermissions(
      user.company.currentSubscription,
      permissions.preCampaignReport.view
    );

    if (!permitted) {
      return;
    }

    if (audience.audienceVariables && audience.audienceVariables.length) {
      history.push({
        pathname: `${routes.fullReport}/${audience.id}/${audience.threshold}/audience`,
        state: { audience }
      });
    } else if (!audience.audienceVariables) {
      history.push({
        pathname: `${routes.fullReport}/${audience.id}/${audience.threshold}/preset`,
        state: { audience }
      });
    }
  };

  handleCheck = () => {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.newBackendSearchOrFiltering();
    }, 1000);
  };

  handleAudienceCreateWithOneCountry = async evt => {
    evt.preventDefault();

    const { history } = this.props;

    await Api.audience.add({
      data: {
        country: this.props.countries[0].name,
        audienceType: "Custom",
        method: "ll"
      }
    });

    history.push({
      pathname: routes.audiencesCreateWithoutTemplate(this.props.created.id),
      state: {
        country: this.props.countries[0].name,
        audience: this.props.created,
        from: "createFromTemplate"
      }
    });
  };

  handleCreateCustomerAnalysisSubmit = async (data, file) => {
    const { countries, history } = this.props;

    const response = await Api.audience.variables({
      params: {
        search: data.name
      }
    });

    if (response.payload.length) {
      this.setState({ customerAnalysisError: true });

      return;
    }

    this.setState({ customerAnalysisError: false });

    const newAudience = await Api.audience.add({
      data: {
        name: data.name,
        client: data.clientsId ? data.clientsId : null,
        country: data.country ? data.country : countries[0].name,
        audienceType: "Custom",
        method: "ll"
      }
    });

    file.set("audience_id", newAudience.id);

    await Api.audience.attachFile({
      params: {
        audience_id: newAudience.id
      },
      data: file
    });

    history.push(
      `${routes.fullReport}/${newAudience.id}/${newAudience.threshold}/audience`
    );
  };

  handleChange(name, value) {
    this.setState({
      [name]: value
    });
  }

  handleChangeFilter(name, value) {
    this.setState(({ filters }) => ({
      filters: {
        ...filters,
        [name]: value
      }
    }));
  }

  handleAudienceCreate(evt) {
    evt.preventDefault();
    this.setState({ curType: "audiences" });
    this.handleDescriptionModal(!!evt);
  }

  handleEditAudience(descriptionData) {
    return this.setState({
      descriptionData,
      isDescriptionModalOpen: true,
      curType: "audience_builder"
    });
  }

  handleDescriptionModal(isDescriptionModalOpen) {
    if (!isDescriptionModalOpen) {
      this.setState({ curType: "" });
    }
    return this.setState({ isDescriptionModalOpen, descriptionData: {} });
  }

  handleLoadMore() {
    const { limit, filters } = this.state;

    const {
      audiences: { audiencesNext, presetsNext, audiencesOffset, presetsOffset },
      user: {
        company: { currentSubscription }
      },
      setAudiencesOffset,
      setPresetsOffset
    } = this.props;

    if (
      currentSubscription !== "Light" &&
      audiencesNext !== "" &&
      filters.createdBy !== "GDR"
    ) {
      setAudiencesOffset(audiencesOffset + limit);
    } else if (currentSubscription === "Light" && presetsNext !== null) {
      setPresetsOffset(presetsOffset + limit);
    } else if (filters.createdBy === "GDR" && presetsNext !== null) {
      setPresetsOffset(presetsOffset + limit);
    } else if (
      audiencesNext === "" &&
      presetsNext === "" &&
      filters.type !== "Custom" &&
      (filters.createdBy === "GDR" ||
        filters.createdBy === "" ||
        filters.createdBy === "All")
    ) {
      this.setState({ loadPresetsAfterAudiences: true });
      setPresetsOffset(0);
    } else if (
      audiencesNext === "" &&
      filters.type !== "Custom" &&
      (filters.createdBy === "GDR" ||
        filters.createdBy === "" ||
        filters.createdBy === "All") &&
      presetsNext !== null
    ) {
      setPresetsOffset(presetsOffset + limit);
    }
  }

  handleBackendSearchTermChange(name, value) {
    this.setState({
      [name]: value
    });
  }

  handleBackendFilterChange(name, value) {
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [name]: value !== "All" ? value : ""
      }
    }));
  }

  async handleDescriptionChange(data = {}) {
    const { isDescriptionModalOpen } = this.state;
    const { history } = this.props;
    if (!data.id) {
      await Api.audience.add({
        data: {
          country: data.country ? data.country : this.props.countries[0].name,
          audienceType: "Custom",
          method: "ll"
        }
      });

      this.handleDescriptionModal(!isDescriptionModalOpen);

      history.push({
        pathname: routes.audiencesCreateWithoutTemplate(this.props.created.id),
        state: {
          country: data.country,
          audience: this.props.created,
          from: "createFromTemplate"
        }
      });
    } else {
      await Api.audience.edit({
        id: data.id,
        data: {
          name: data.name,
          client: data.clientsId
        }
      });
      this.handleDescriptionModal(!isDescriptionModalOpen);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async removeAudience(id) {
    await Api.audience.remove({ id });
  }

  async newBackendSearchOrFiltering(isNewBackendSearchOrFiltering) {
    const {
      user: {
        company: { currentSubscription }
      },
      clearState
    } = this.props;

    const { filters } = this.state;

    clearState();

    if (
      currentSubscription === "Light" ||
      ["pre-build", "tgi"].includes(filters.type)
    ) {
      await this.getPresets(isNewBackendSearchOrFiltering);
    } else {
      await this.getAudiences(isNewBackendSearchOrFiltering);
    }
  }

  render() {
    document.title = "Audiences | Global Data Resources";
    const {
      curType,
      filters,
      descriptionData,
      isDescriptionModalOpen,
      isSelectClientModalHasOpened
    } = this.state;
    const {
      companyPlan,
      user,
      history,
      location,
      clients,
      countries,
      userProfiles,
      audiences: {
        data,
        presets,
        audiencesNext,
        presetsNext,
        isLoadingAudiences,
        isLoadingPresets,
        isDubliciting,
        isShareAudienceLoading
      }
    } = this.props;

    const showLoadingIndicator =
      isLoadingAudiences ||
      isLoadingPresets ||
      isDubliciting ||
      isShareAudienceLoading;
    let showLoadMoreButton;

    if (audiencesNext === "" && presetsNext === "") showLoadMoreButton = false;
    else if (filters.type === "Custom" && audiencesNext === "")
      showLoadMoreButton = false;
    else if (
      (data.length || presets.length) &&
      (audiencesNext || presetsNext !== "") &&
      !showLoadingIndicator
    ) {
      showLoadMoreButton = true;
    } else if (
      data.length < 15 &&
      presets.length === 0 &&
      audiencesNext === null &&
      presetsNext === "" &&
      (filters.createdBy !== "" ||
        filters.createdBy !== "All" ||
        filters.createdBy !== "GDR") &&
      !showLoadingIndicator
    ) {
      showLoadMoreButton = false;
    } else {
      showLoadMoreButton = false;
    }

    const dataForTableRows = [
      ...data,
      ...presets.map(preset => ({
        ...preset,
        isPreset: true
      }))
    ];

    return (
      <Container ref={this.audienceRef} id="audiences" fluid>
        <div className="audiences-background">
          <div className="background-light" />
        </div>
        <Container className="audiences-container">
          <Row>
            {/* <HeaderComponent /> */}
            <Header isShowProfilePopover={this.state.isShowProfilePopover} />
          </Row>
          <Row className="audiences-dashboard">
            <div className="dashboard">
              {/* <Col className="dashboard-container"> */}
              {/*  <h1 className="title">Audiences</h1> */}
              {/*  <p className="description"> */}
              {/*    Below are all the audiences you have designed or have access */}
              {/*    to. */}
              {/*    <br /> */}
              {/*    Pre-sets are designed and quality tested by us. */}
              {/*  </p> */}
              {/* </Col> */}
              <Col className="dashboard-container">
                {user.company && (
                  <AccessControl allow={permissions.audienceBuilder.view}>
                    <div className="d-flex ml-auto">
                      <Button
                        onClick={() =>
                          this.setState({
                            isAnalysisModalOpen: true
                          })
                        }
                        className="analysis-button"
                      >
                        <span>ANALYZE OWN DATA</span>
                      </Button>
                      <NavLink
                        to={routes.audiencesCreate}
                        onClick={
                          countries.length === 1
                            ? this.handleAudienceCreateWithOneCountry
                            : this.handleAudienceCreate
                        }
                        onKeyPress={
                          countries.length === 1
                            ? this.handleAudienceCreateWithOneCountry
                            : this.handleAudienceCreate
                        }
                        className="button add-button"
                      >
                        <SVG.Plus className="icon" />
                        <span>Add Audience</span>
                      </NavLink>
                    </div>
                  </AccessControl>
                )}
              </Col>
            </div>
          </Row>
          <Row className="audiences-tools">
            <div className="tools">
              <SearchInput
                value={this.state.backendSearchTerm}
                name="backendSearchTerm"
                handleChange={this.handleBackendSearchTermChange}
              />

              <Filters
                filters={filters}
                audiences={dataForTableRows}
                countries={countries}
                userProfiles={userProfiles}
                onChangeFilter={this.handleBackendFilterChange}
                currentSubscription={user.company.currentSubscription}
              />
            </div>
          </Row>
          <Row className="audiences-content">
            <Table>
              <thead>
                <tr>
                  <th className="name">Name</th>
                  {/* <th className="id">ID</th> */}
                  <th className="reach">Reach</th>
                  <th className="type">Type</th>
                  <th className="country">Country</th>
                  <th className="created-at">Created</th>
                  {/* <th className="quality-indicator">Quality Indicator</th> */}
                  {user.company.currentSubscription !== "Light" && (
                    <th className="options"></th>
                  )}
                </tr>
              </thead>
              <tbody>
                {dataForTableRows.map(audience => {
                  return (
                    <AudienceRow
                      key={`audience-row-${audience.id}`}
                      isSelectClientModalHasOpened={
                        isSelectClientModalHasOpened
                      }
                      setIsSelectClientModalHasOpened={state =>
                        this.setState({ isSelectClientModalHasOpened: state })
                      }
                      currentSubscription={
                        this.props.user?.company?.currentSubscription || "Light"
                      }
                      clients={clients}
                      companyPlan={companyPlan}
                      audience={audience}
                      canEdit={
                        audience.audienceVariables
                          ? user?.role === "admin" || user?.role === "gdr admin"
                          : false
                      }
                      canRemove={
                        audience.audienceVariables
                          ? user?.role === "admin" || user?.role === "gdr admin"
                          : false
                      }
                      user={user}
                      onEdit={() => this.handleEditAudience(audience)}
                      onEditBuilder={() => {
                        return (
                          audience.audienceVariables &&
                          history.push(
                            routes.audiencesCreateWithoutTemplate(audience.id),
                            {
                              selectedVariables: audience.audienceVariables,
                              country: audience.country.name,
                              audience
                            }
                          )
                        );
                      }}
                      onRemove={() => this.removeAudience(audience.id)}
                      onClick={() => this.handleAudienceRowClick(audience)}
                    />
                  );
                })}
              </tbody>
            </Table>
            {showLoadingIndicator && (
              <div className="audience-loader-container">
                <LoadingIndicator />
              </div>
            )}

            {showLoadMoreButton && (
              <Button
                style={{ margin: "0 auto" }}
                onClick={this.handleLoadMore}
                className="button"
              >
                <span>Load more</span>
              </Button>
            )}
          </Row>
        </Container>
        <ModalAudienceForm
          modalTitle="Edit audience"
          data={descriptionData}
          type={curType}
          clients={clients}
          countries={countries}
          isOpen={isDescriptionModalOpen}
          canChangeClient={user?.role === "admin" || user?.role === "gdr admin"}
          changeModalState={() =>
            this.handleDescriptionModal(!isDescriptionModalOpen)
          }
          handleSubmit={this.handleDescriptionChange}
        />
        <ModalAudienceForm
          customerAnalysisError={this.state.customerAnalysisError}
          data={countries.length === 1 ? { country: countries[0] } : {}}
          type=""
          clients={clients}
          countries={countries}
          isOpen={this.state.isAnalysisModalOpen}
          withFileUpload
          changeModalState={() =>
            this.setState(prevState => ({
              isAnalysisModalOpen: !prevState.isAnalysisModalOpen
            }))
          }
          handleSubmit={this.handleCreateCustomerAnalysisSubmit}
        />
        <PushModal
          isOpen={this.state.isShowPushModal}
          onClose={() => this.setState({ isShowPushModal: false })}
          // audience={this.props.location.state}
          audience={location.state?.audience}
          clientId={location.state?.clientId}
          adformToken={this.state.adformToken}
          snapchatToken={this.state.snapchatToken}
          user={user}
          currentSubscription={user.company.currentSubscription}
        />
        <ModalShare />
      </Container>
    );
  }
}
const mapStateToProps = ({
  audiences,
  audienceSlice,
  clients,
  userProfile
}) => {
  return {
    userProfiles: userProfile.profiles,
    companyPlan: userProfile.companyPlan,
    user: userProfile.user,
    audiences: {
      ...audiences,
      isDublicateSuccess: audienceSlice.isDublicateSuccess,
      isDubliciting: audienceSlice.isDubliciting,
      isShareAudienceLoading: audienceSlice.isShareAudienceLoading
    },

    countries: audiences.countries,
    clients: clients.data,
    created: audiences.added
  };
};

const mapDispatchToProps = {
  setAudiencesOffset: setAudiencesPaginationOffset,
  setPresetsOffset: setPresetsPaginationOffset,
  clearAudiencesInState: clearAudiences,
  clearPresetsInState: clearPresets,
  clearState: clearStateBeforeSearchRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(AudienceScreen);

AudienceScreen.propTypes = {
  setAudiencesOffset: PropTypes.func.isRequired,
  setPresetsOffset: PropTypes.func.isRequired,
  clearState: PropTypes.func.isRequired,
  user: PropTypes.shape({
    role: PropTypes.string,
    company: PropTypes.shape({
      currentSubscription: PropTypes.string
    })
  }).isRequired,
  companyPlan: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  audiences: PropTypes.shape({
    presets: PropTypes.arrayOf(PropTypes.shape({})),
    data: PropTypes.arrayOf(PropTypes.shape({})),
    audiencesNext: PropTypes.string,
    presetsNext: PropTypes.string,
    audiencesOffset: PropTypes.number,
    presetsOffset: PropTypes.number,
    isLoadingAudiences: PropTypes.bool,
    isLoadingPresets: PropTypes.bool,
    isDublicateSuccess: PropTypes.bool.isRequired,
    isDubliciting: PropTypes.bool.isRequired,
    isShareAudienceLoading: PropTypes.bool.isRequired
  }).isRequired,
  clients: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string }))
    .isRequired,
  userProfiles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
    state: PropTypes.shape({
      audience: PropTypes.shape({}),
      clientId: PropTypes.string
    }).isRequired
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
    replace: PropTypes.func
  }).isRequired,
  created: PropTypes.shape({
    id: PropTypes.string
  })
};

AudienceScreen.defaultProps = {
  created: {}
};
